import React, { memo, useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FullscreenExitIcon from 'mdi-react/FullscreenExitIcon';
import { AppContext } from '@prisjakt/ui-app-context';
import sidebarFilterActions from '../../../sidebar/actions/filter';

import * as S from './styles';

const FilterToggle = ({
  expanded,
  toggleHorizontalFilter,
  toggleSidebarFilter,
}) => {
  const { t } = useContext(AppContext);
  const label = expanded
    ? t('filter', 'button.toggle-filter')
    : t('filter', 'button.toggle-filter-expand');

  return (
    <S.Tooltip placement="right" title={label}>
      <S.SidebarFilterButton
        onClick={() => {
          toggleHorizontalFilter();
          toggleSidebarFilter();
        }}
        icon={<FullscreenExitIcon size={30} />}
        variant="icon"
        title={label}
        scaleIcon={false}
        size="large"
      />
    </S.Tooltip>
  );
};

FilterToggle.propTypes = {
  expanded: PropTypes.bool,
  toggleHorizontalFilter: PropTypes.func.isRequired,
  toggleSidebarFilter: PropTypes.func.isRequired,
};

FilterToggle.defaultProps = {
  expanded: false,
};

const dispatchProps = {
  toggleSidebarFilter: sidebarFilterActions.toggleFilter,
};

export default connect(null, dispatchProps)(memo(FilterToggle));
